var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1747_71)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 1.66675C6.77508 1.66675 4.16675 4.27508 4.16675 7.50008C4.16675 11.8751 10.0001 18.3334 10.0001 18.3334C10.0001 18.3334 15.8334 11.8751 15.8334 7.50008C15.8334 4.27508 13.2251 1.66675 10.0001 1.66675ZM5.83341 7.50008C5.83341 5.20008 7.70008 3.33341 10.0001 3.33341C12.3001 3.33341 14.1667 5.20008 14.1667 7.50008C14.1667 9.90008 11.7667 13.4917 10.0001 15.7334C8.26675 13.5084 5.83341 9.87508 5.83341 7.50008Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 9.58341C11.1507 9.58341 12.0834 8.65067 12.0834 7.50008C12.0834 6.34949 11.1507 5.41675 10.0001 5.41675C8.84949 5.41675 7.91675 6.34949 7.91675 7.50008C7.91675 8.65067 8.84949 9.58341 10.0001 9.58341Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1747_71"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6cb023cbd2a0c2bb608c335aa8f46313.svg";
export { ForwardRef as ReactComponent };